import { isValidHost } from '../helpers.esm.js';

function readHarnessConfig(config) {
  const host = config.getString("host");
  const token = config.getOptionalString("token");
  const apiKey = config.getOptionalString("apiKey");
  if (!isValidHost(host)) {
    throw new Error(
      `Invalid Harness Code integration config, '${host}' is not a valid host`
    );
  }
  return {
    host,
    apiKey,
    token
  };
}

export { readHarnessConfig };
//# sourceMappingURL=config.esm.js.map
